// extracted by mini-css-extract-plugin
export var footer = "_oq-0";
export var inherit = "_oq-1";
export var input = "_oq-2";
export var modalContent = "_oq-3";
export var quillEditor = "_oq-4";
export var subtitle = "_oq-5";